// extracted by mini-css-extract-plugin
export default {"section":"FormSection_section__0Mvut","title":"FormSection_title__7c3H5","grid":"FormSection_grid__i5owM"};